import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Suppress React DOM errors related to removeChild
// These occur when third-party libraries (like Owl Carousel) modify DOM structure
// and React tries to remove nodes that no longer exist in the expected structure
const originalRemoveChild = Node.prototype.removeChild;
Node.prototype.removeChild = function(child) {
  try {
    if (this.contains(child)) {
      return originalRemoveChild.call(this, child);
    }
  } catch (error) {
    // Silently ignore removeChild errors - node was already removed or doesn't exist
    // This is expected when third-party libraries modify DOM structure
    console.warn('Suppressed removeChild error (expected with third-party DOM manipulation):', error.message);
  }
  return child;
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
